import * as utils from '../../utils/schoolUtils'
import { Student } from './student'
import { Teacher } from './teacher'

export class User{


  constructor({ name, type, admissionNo, blocked = false, userId, password, profileUrl=null, blockReason=null,
    roleToken=''
   }) {
    this.name = name;
    this.admissionNo = admissionNo;
    this.registeredNumber = 0;
    this.type = type; // 0 = teacher, 1 = student
    this.fathername = null;
    this.password = password || '';
    this.student = null;
    this.teacher = new Teacher();
    this.class = null;
    this.sec = null;
    this.blocked = blocked;
    this.userId = userId;
    this.profileUrl = profileUrl;
    this.blockReason = blockReason;
    this.roleToken = roleToken || 'no_role_token';
  }


      static fromDataTable(row, type = 1) {
        const user = new User({ type });
        if (type === 1) {
          user.admissionNo = utils.getFormattedAdmissionNo(row[2].toString());
        }
        user.name = row[1];
        user.registeredNumber = 0;
        user.class = type === 1 ? user._getClass(row[4]) : null;
        user.sec = type === 1 ? (row[5] ? row[5].toString().trim() : null) : null;

        user.blocked = false;
        user.blockReason = null;
        return user;
      }

      static fromMap(map, schoolId) {
        const user = new User({ type: map.type });
        user.name = map.name;
        user.admissionNo = map.admissionNo;
        user.registeredNumber = map.registeredNumber;
        user.password = map.password;
        user.class = map.Class;
        user.sec = map.sec;
        user.blocked = map.blocked;
        user.userId = map.userId;
        user.schoolId = schoolId;
        user.profileUrl = map.profileUrl;
        user.blockReason = map.blockReason;
        user.roleToken = map.roleToken || 'no_role_token';
        if(user.type ==1){
          user.student = Student.fromMap(map.student);
        }else{
          user.teacher = Teacher.fromMap(map.teacher);
        }
        return user;
      }

      toMap() {
        const map = {
          name: this.name,
          registeredNumber: this.registeredNumber,
          Class: this.class ?? -2,
          sec: this.sec,
          type: this.type,
          password: this.password,
          userId: this.userId,
          profileUrl: this.profileUrl,
          roleToken: this.roleToken || 'no_role_token',
        };
        if (this.type === 1) {
          map.admissionNo = this.admissionNo;
          map.blocked = false;
          map.student = this.student ? this.student.toMap() : null;
          map.blockReason = this.blockReason;
        }
        if (this.type === 0) {
          map.teacher = this.teacher ? this.teacher.toMap() : null;
        }
        return map;
      }
      

  _getClass(_class) {
    if (!_class) {
      return -3;
    } else {
      if(utils.isRomanNumeral(_class)){
        return utils.convertRomanToInteger(_class);
      }
      const classStr = _class.toString().trim().toLowerCase().replace(/\s+/g, '');
      if (classStr.includes('ukg') || classStr.includes('fly3')) {
        return 0;
      } else if (classStr.includes('lkg') || classStr.includes('fly2')) {
        return -1;
      } else if (classStr.includes('prekg') || (classStr.includes('pre-kg'))) {
        return -2;
      } else {
        return parseInt(classStr, 10);
      }
    }
  }

  _getAdmNo(admNo) {
    if (admNo.includes('KG')) {
      const numberOnly = admNo.toString().substring(2);
      return parseInt(numberOnly, 10);
    } else {
      return admNo;
    }
  }
}

export const BlockReasons = {
  LEAVE_SCHOOL: 'This student has left the school',
  DISMISSED: 'This student is dismissed from the school',
  FEE_DUE: 'This student has unpaid fees',
  OTHER: 'Some other reason'
}

